'use client'

import React from 'react';
import dynamic from 'next/dynamic';
import animationData from '../lottie/business-main.json';

const LazyLottie = dynamic(() => import('react-lottie-player').then((mod) => mod), { ssr: false });

export interface BusinessMainIconLottieProps {
  className?: string;
  style?: React.CSSProperties;
  loop?: boolean;
  play?: boolean;
  speed?: number;
}

const BusinessMainIconLottie: React.FC<BusinessMainIconLottieProps> = ({
  className,
  style,
  loop = true,
  play = true,
  speed = 1,
}) => {
  return (
    <LazyLottie
      animationData={animationData}
      className={className}
      style={style}
      loop={loop}
      play={play}
      speed={speed}
    />
  );
};

export default BusinessMainIconLottie;
